<template>
	<div class="main">
		<section class="panel">
			<ul id="FeeTypeNav" class="nav nav-tabs" role="tablist">
				<li :class="{active: qryParam.feeType == 'N'}">
					<a data-toggle="tab" @click="changeFeeTypeTab('N')">減免費用設定</a>
				</li>
				<li :class="{active: qryParam.feeType == 'G'}">
					<a data-toggle="tab" @click="changeFeeTypeTab('G')">軍公教補助費用設定</a>
				</li>
			</ul>
			<section class="panel panel-default">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse in">
					<div class="panel-body">
                        <div class="form-inline">
                            <div class="row form-group">
                                <div class="col-md-12">
                                    <label>學期</label>
                                    <select v-model="qryParam.smtr" class="form-control">
                                        <option value="">請選擇</option>
                                        <option v-for="(smtr, index) in selectSmtr()" :key="index" :value="smtr.value" :selected="index == 0">{{smtr.text}}</option>
                                    </select>
                                </div>
                            </div>
							<button @click="updateGrid(1)" class="btn s_btn_b">查詢</button>
							<button @click="clearSearchParam" class="btn s_btn_g">清除</button>
            </div>
					</div>
				</div>
			</section>
			<section class="panel panel-default">
                <div class="tab-content">
                    <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
                        <div class="row form-group">
                            <div class="col-md-12 text-right form-inline">
                                <button @click="showEditPopup(true)" class="btn btn-primary" v-if="qryParam.feeType == 'N'">新增減免費用設定</button>
                                <button @click="showEditPopup(true)" class="btn btn-primary" v-if="qryParam.feeType == 'G'">新增軍公教遺族補助費設定</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-no-more table-bordered table-striped mb-none" >
                                    <thead>
                                        <tr v-if="qryParam.feeType == 'N'">
                                            <th class="text-center" width="7.5%">學期</th>
                                            <th class="text-center" width="15%">申請類別</th>
                                            <th class="text-center" width="10%">計算方式</th>
                                            <th class="text-center" width="15%">科系別</th>
                                            <th class="text-center" width="7.5%">部別</th>
                                            <th class="text-center" width="7.5%">學費</th>
                                            <th class="text-center" width="7.5%">雜費</th>
                                            <th class="text-center" width="7.5%">保險費</th>
                                            <th class="text-center" width="7.5%">折扣百分比</th>
                                            <th class="text-center" width="7.5%">修改</th>
                                            <th class="text-center" width="7.5%">刪除</th>
                                        </tr>
                                        <tr v-if="qryParam.feeType == 'G'">
                                            <th class="text-center" width="15%">學期</th>
                                            <th class="text-center" width="20%">申請類別</th>
                                            <th class="text-center" width="15%">書籍費</th>
                                            <th class="text-center" width="15%">制服費</th>
                                            <th class="text-center" width="15%">生活費</th>
                                            <th class="text-center" width="10%">修改</th>
                                            <th class="text-center" width="10%">刪除</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="qryParam.feeType == 'N'">
                                        <tr v-for="(item, index) in feeList" :key="index">
                                            <td data-title="學期" class="text-center" >{{item.smtr}}</td>
                                            <td data-title="申請類別" class="text-center" >{{item.reliefTypeStr}}</td>
                                            <td data-title="計算方式" class="text-center" >{{item.countTypeStr}}</td>
                                            <td data-title="科系別" class="text-center" >{{item.deptTypeStr}}</td>
                                            <td data-title="部別" class="text-center" >{{item.kindTypeStr}}</td>
                                            <td data-title="學費" class="text-center" >{{item.tuitionFee}}</td>
                                            <td data-title="雜費" class="text-center" >{{item.miscellaneousFee}}</td>
                                            <td data-title="保險費" class="text-center" >{{item.insurancePremium}}</td>
                                            <td data-title="折扣百分比" class="text-center" >{{item.discountPercent != null ? item.discountPercent + '%' : ''}}</td>
                                            <td data-title="修改" class="text-center" >
                                                <button @click="showEditPopup(true, item.id)" class="btn s_btn_o">修改</button>
                                            </td>
                                            <td data-title="刪除" class="text-center" >
                                                <button @click="handleDelete(item.id)" class="btn btn-primary">刪除</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="qryParam.feeType == 'G'">
                                        <tr v-for="(item, index) in feeList" :key="index">
                                            <td data-title="學期" class="text-center" >{{item.smtr}}</td>
                                            <td data-title="申請類別" class="text-center" >{{item.reliefTypeStr}}</td>
                                            <td data-title="書籍費" class="text-center" >{{item.bookFee}}</td>
                                            <td data-title="制服費" class="text-center" >{{item.uniformFee}}</td>
                                            <td data-title="生活費" class="text-center" >{{item.livingFee}}</td>
                                            <td data-title="修改" class="text-center" >
                                                <button @click="showEditPopup(true, item.id)" class="btn s_btn_o">修改</button>
                                            </td>
                                            <td data-title="刪除" class="text-center" >
                                                <button @click="handleDelete(item.id)" class="btn btn-primary">刪除</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">
                                    <pageControl :page="page" :total="totalPage"></pageControl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</section>
		</section>
		<editPopup v-if="isShoweditPopup" :fee-type="qryParam.feeType" :id="selectedId"/>
	</div>
</template>
<script>
import editPopup from './editPopup';
export default {
	components:{
		editPopup
	},
	data() {
		return {
			qryParam:{
				feeType: "N",
				smtr: ""
			},
			feeList: [],
			page: 1,
			totalPage: 1,
			isShoweditPopup: false,
			selectedId: '',
            smtrList: [],
		};
	},
	mounted() {
    const api = "/api/reliefFee/smtrList";
    this.$axios.get(api).then(resp => {
        this.smtrList = resp.data.data;
        if(this.smtrList.length == 0) {
            this.smtrList = ['1111'];
        }
        if(this.smtrList.length > 0) {
            this.qryParam.smtr = this.smtrList[0];
        }
    this.updateGrid();
    });
	},
	methods: {
    changeFeeTypeTab(type){
        if(this.qryParam.feeType != type) {
            this.page = 1;
            this.qryParam.feeType = type;
            this.updateGrid();
        }
    },
		showEditPopup(isOpen, selectedId = '') {
			this.selectedId = selectedId;
			this.isShoweditPopup = isOpen;
			if(!isOpen) {
				this.updateGrid(this.page);
			}
		},
		updateGrid(page = 1){
      this.page = page;
			const api = "/api/reliefFee";
			const query = new URLSearchParams({
				smtr: this.qryParam.smtr,
				feeType: this.qryParam.feeType,
				page: this.page,
				pageSize: 10,
			}).toString();
			this.$axios.get(api + '?' + query).then(resp =>{
				this.feeList = resp.data.data.rows;
				this.totalPage = Math.ceil(resp.data.data.rowNum / resp.data.data.pageSize);
				this.page = resp.data.data.page;
			});
		},
		clearSearchParam(){
			this.qryParam.smtr= "";
		},
		handleDelete(selectId) {
			const _this = this
			bootbox.confirm("是否刪除此筆費用設定", function(result){
				if(result){
					const api = `/api/reliefFee/${selectId}`;
					_this.$axios.delete(api).then(resp => {
						if (resp.data.status === "success") {
							bootbox.alert("刪除成功");
							_this.updateGrid(this.page);
						} else {
							bootbox.alert(resp.data.msg);
						}
					});
				}
			});
		},
		selectSmtr(){
			let smtrArray = [];
            this.smtrList.forEach(smtr=> {
                const year = smtr.substring(0,3);
                const semester = smtr.substring(3,4) == 1 ? '一' : '二';
                smtrArray.push({
                    text: `${year}學年度第${semester}學期`,
                    value: smtr
                });
            });
			return smtrArray;
		},
	},
	computed: {
	}
};
</script>

